export default "__VITE_ASSET__DYB0fbJX__"